export enum LayoutStyle {
  Sidebar = 'sidebar',
  TopHeader = 'topHeader',
  Custom = 'custom',
}
